// extracted by mini-css-extract-plugin
export default {"wrapper":"icons-page_wrapper__9uha4","p":"icons-page_p__0J7pw","moreicon":"icons-page_moreicon__fAUK0"};